import { render } from "./CashbackRanges.vue?vue&type=template&id=86ccf71c&scoped=true"
import script from "./CashbackRanges.vue?vue&type=script&lang=js"
export * from "./CashbackRanges.vue?vue&type=script&lang=js"

import "./CashbackRanges.vue?vue&type=style&index=0&id=86ccf71c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ccf71c"]])

export default __exports__